import { Star } from "lucide-react";

export function Stars({ rating = 5, size = 14 }) {
  const full = Math.round(rating);
  return (
    <span className="inline-flex items-center gap-0.5" aria-label={`${rating} stars`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} size={size} className={i <= full ? "fill-gold text-gold" : "text-slate-300"} />
      ))}
    </span>
  );
}
